import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocalStorageService } from 'angular-2-local-storage';
import * as CryptoJS from 'crypto-js';
import * as cloneDeep from 'lodash/cloneDeep';

import { HalApiCaller } from '@dxc-technology/halstack-client';
import { AlertService } from './alert.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  header;
  userProfile;
  tokenInfo;
  public signedIn: boolean;
  accessToken;
  authorizationCode;
  roles: any;
  grantAccess: boolean;
  userRoles: any;
  userdetails
  Active_Profile = environment.ENV_ACTIVE_PROFILE;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_PREMISES = environment.ON_PREMISES;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  role: any;
  defaultClaimAuthority: any = {
    beneficiary: {
      actions: {
        Add: false,
        Delete: false,
        Edit: false,
        Approve: false,
      },
    },
    investigationSubtask: {
      actions: {
        approveSubtask: false,
        createSubtask: false,
      },
      departments: [
        {
          department: '',
        },
      ],
    },
    assessor: {
      actions: {
        No: true,
        Yes: false,
      },
      limits: '0',
    },
    holdPayments: {
      actions: {
        No: true,
        Yes: false,
      },
    },
  };
  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private storage: LocalStorageService,
    private alertService: AlertService,
    private _leadCommonService: CommonService
  ) {
    this.header = this.getHeaders();
  }

  getHeaders() {
    let userrole=localStorage.getItem('userRole')
    let buttonEnable = 'N';
    if (this.userdetails) {
      if (this.userdetails.businessDateEnable == 'Yes') {
        buttonEnable = 'Y';
      }
    }
    const commonHeaders = {
      authorization: 'Bearer ' + localStorage.getItem('access_token'),
      createUser:localStorage.getItem('userName')!= undefined&&localStorage.getItem('userName')!=null?localStorage.getItem('userName'):'',
      country:localStorage.getItem('regionSelected')!= undefined&&localStorage.getItem('regionSelected')!=null?localStorage.getItem('regionSelected'):'',
      language:localStorage.getItem('language')!= undefined&&localStorage.getItem('language')!=null?localStorage.getItem('language'):'',
      businessdateenable: buttonEnable,
      lob: userrole != undefined && userrole != null ? userrole.replace(userrole=='L_CO'||userrole=='C_L_CO'?'_CO':'_CF', '') : ''
    };
    // Cloud
    if (this.ON_CLOUD === this.PROFILE) {
        commonHeaders['x-api-key'] = environment.COGNITO.x_api_key
    }
    return commonHeaders;
  }

  //cognito login url
  redirectToLogin() {
    localStorage.setItem('token', '');
    let region = localStorage.getItem('regionSelected');
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('isLogin', 'yes');
    localStorage.setItem('regionSelected', region);
    sessionStorage.setItem('regionSelected',region);
    const params = [
      'identity_provider=' + environment.COGNITO.identity_provider,
      'response_type=' + environment.COGNITO.response_type,
      'client_id=' + environment.COGNITO.ClientId,
      'scope=' + environment.COGNITO.scope,
      'redirect_uri=' + encodeURIComponent(environment.COGNITO.redirectUri),
    ];
    window.location.href =
      environment.COGNITO.LoginUrl + '?' + params.join('&');
  }

  private strRandom(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  // CAS_Login
  CAS_LoginPage() {
    const state = this.strRandom(40);
    const codeVerifier = this.strRandom(128);
    localStorage.setItem('codeVerifier', codeVerifier);
    this.storage.set('state', state);
    this.storage.set('codeVerifier', codeVerifier);

    const codeVerifierHash = CryptoJS.SHA256(codeVerifier).toString(
      CryptoJS.enc.Base64
    );

    const codeChallenge = codeVerifierHash
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');

    const params = [
      'response_type=code',
      'state=' + state,
      'client_id=' + environment.OAUTH2_CAS.ClientId,
      'scope=openid',
      'code_challenge=' + codeChallenge,
      'code_challenge_method=S256',
      'redirect_uri=' + encodeURIComponent(environment.OAUTH2_CAS.CallbackUrl),
    ];
    localStorage.setItem('access_token', '');
    sessionStorage.setItem('isLogin', 'yes');
    window.location.href =
      environment.OAUTH2_CAS.LoginUrl + '?' + params.join('&');
  }
  //get Token CAS
  async getToken_CAS(code: string) {
    const payload = new HttpParams()
      .append('grant_type', 'authorization_code')
      .append('scope', 'openid')
      .append('client_id', environment.OAUTH2_CAS.ClientId)
      .append('code_verifier', localStorage.getItem('codeVerifier'))
      .append('redirect_uri', environment.OAUTH2_CAS.CallbackUrl)
      .append('code', code);
    let tokenInfo: any = this.http
      .post<any>(environment.OAUTH2_CAS.TokenUrl, payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (error) => {
          return { error: error };
        }
      );
    return tokenInfo;
  }
  //get access token

  async getAccessToken(authorizationCode: string) {
    let headers: any = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    let urlToken = environment.COGNITO.TokenUrl;
    let payload = new HttpParams()
      .append('grant_type', 'authorization_code')
      .append('client_id', environment.COGNITO.ClientId)
      .append('code', authorizationCode)
      .append('redirect_uri', environment.COGNITO.redirectUri);
    let response: any = await this.http
      .post<any>(urlToken, payload, { headers })
      .toPromise()
      .then(
        (data) => {
          return data;
        },
        (error) => {
          return { error: error };
        }
      );
    if (
      !response ||
      (response && response.hasOwnProperty('error')) ||
      response.hasOwnProperty('errors')
    ) {
      return '';
    } else {
      let ac = response.access_token;
      let id_token = response.id_token;
      sessionStorage.setItem('id_token', id_token);
      localStorage.setItem('access_token', ac);
      this.accessToken = ac;
      return this.accessToken;
    }
  }

  async getUserRoles(username: string) {
    try {
      let res = await HalApiCaller.get({
        url:
          environment.API_CONFIG_URL +
          'userrole-service/userdata/' +
          username +
          '/getUserProfile?list=userInfo,roles',
        headers: this.getHeaders(),
      });
      this._leadCommonService.userdetails=res.body
      this.userRoles=res.body
      localStorage.setItem('userModelId', this.userRoles.userModelId);
      let userModel = await this.getProfileAdministartionById(this.userRoles.userModelId);
      let roleExit=userModel.profiles.filter(data=>(data.roleType === 'L_CF' || data.roleType === 'C_L_CF') && data.country === localStorage.getItem('regionSelected'))
      if(roleExit.length==0){
      for (let item of userModel.profiles) {
        if ((item.roleType == 'L_CO' || item.roleType == 'C_L_CO')&& item.country == localStorage.regionSelected) {
          let claimAuthority = item.claimAuthority;
          if (!claimAuthority) {
            item.claimAuthority = cloneDeep(this.defaultClaimAuthority);
          }
          localStorage.setItem('claimAuthority', JSON.stringify(item.claimAuthority));
        }
      }
     }
      return res.body;
    } catch (error) {
      this._leadCommonService.changespinnerMessage(false);
      this.alertService.error(error);
    }
  }
  async getProfileAdministartionById(userId) {
    try {
      let url = environment.API_CONFIG_URL + 'userrole-service/users/' + `${userId}`;
      let response = await this._leadCommonService.commonGet(url);
      if (response.status !== undefined && response.status === 200) {
        let profileDetail = response.body;
        return profileDetail;
      } else {
        return null;
      }
    } catch (error) {
      return error;
    }
  }
  isValidUserRole(res): boolean {
    this.role = res.profile;
    this.grantAccess = false;
    let roleExit=this.role.filter(data=>(data.roleType === 'L_CF' || data.roleType === 'C_L_CF') && data.country === localStorage.getItem('regionSelected'))
      if(roleExit.length!=0){
        localStorage.setItem('userRole', roleExit[0].roleType);
        this.grantAccess = true;
      }else{
        let roleExits=this.role.filter(data=>(data.roleType === 'L_CO' || data.roleType === 'C_L_CO') && data.country === localStorage.getItem('regionSelected'))
        if(roleExits.length!=0){
          localStorage.setItem('userRole', roleExits[0].roleType);
          this.grantAccess = true;
        }
      }
    return this.grantAccess;
  }
}
